<template>
  <div>
    <Head :title="`${expenseDescription.name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-2xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/expense-descriptions">Uraian Biaya</Link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ expenseDescription.name }}
      </h1>
    </div>
    <div class="w-full bg-white rounded-md shadow">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nama Uraian Biaya" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            <font-awesome-icon icon="fas fa-floppy-disk" class="mr-2" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    FontAwesomeIcon,
  },
  layout: Layout,
  props: {
    expenseDescription: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.expenseDescription.name,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/expense-descriptions/${this.expenseDescription.id}`)
    },
  },
}
</script>
